export default "__VITE_ASSET__rO$0Qj_2__"